// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c18792ed","241":"c299d01f","431":"8ef2b4db","489":"730dd804","507":"45f0b9fd","608":"512a2b54","787":"07649a80"}[chunkId] + ".chunk.js";
};